//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RightToolbar from '@/components/RightToolbar/index.vue';
import { appletListApi } from "@/api/operation/applet";
import { getOrderListApi, repairOrderApi } from '@/api/marketing/fortune/order';
export default {
  name: 'FortuneOrder',
  components: {
    RightToolbar: RightToolbar
  },
  data: function data() {
    return {
      loading: false,
      appList: []
    };
  },
  computed: {
    formData: function formData() {
      return [
      // { label: '订单号', prop: 'activityName', defaultValue: '', type: 'input' },
      // { label: '支付状态', prop: 'application', defaultValue: '', type: 'select', options: { list: this.appList } },
      {
        label: '下单时间',
        prop: 'createTime',
        defaultValue: [],
        type: 'datetimeRange',
        options: {
          startKey: 'startTime',
          endKey: 'endTime',
          startPlaceholder: '开始时间',
          endPlaceholder: '结束时间'
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'id',
        visible: true,
        label: "\u8BA2\u5355ID",
        width: 70
      }, {
        key: 'user',
        visible: true,
        label: "\u4E0B\u5355\u7528\u6237",
        width: 160
      }, {
        key: 'appName',
        visible: true,
        label: "\u6240\u5C5E\u5E94\u7528",
        width: 160
      }, {
        key: 'productName',
        visible: true,
        label: "\u4EA7\u54C1\u540D\u79F0",
        width: 160
      }, {
        key: 'amount',
        visible: true,
        label: "\u652F\u4ED8\u91D1\u989D\uFF08\u5143\uFF09",
        width: 100
      }, {
        key: 'paymentMethod',
        visible: true,
        label: "\u652F\u4ED8\u65B9\u5F0F",
        width: 100
      }, {
        key: 'paidTime',
        visible: true,
        label: "\u521B\u5EFA\u65F6\u95F4",
        width: 140
      }];
    }
  },
  created: function created() {
    this.getAppList();
  },
  methods: {
    getAppList: function getAppList() {
      var _this = this;
      var params = {
        page: 1,
        limit: 1000
      };
      appletListApi(params).then(function (data) {
        _this.appList = (data.list || []).map(function (item) {
          item.label = item.appName;
          item.value = item.appId;
          return item;
        });
      });
    },
    refreshList: function refreshList() {
      this.$refs.searchPage && this.$refs.searchPage.refresh();
    },
    resetList: function resetList() {
      this.$refs.searchPage && this.$refs.searchPage.resetSearch();
    },
    getList: function getList(query) {
      return getOrderListApi(query).then(function (res) {
        var list = (res.list || []).map(function (item) {
          item.sortTmp = item.sort;
          item.winConfig = item.activityType === 2 ? item.winConfig : 0;
          return item;
        });
        return {
          list: list,
          total: res.total
        };
      });
    },
    formatter: function formatter(key, value) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
      var defaultValue = type === 'text' ? '-' : '';
      var valueKey = type === 'text' ? 'label' : 'tag';
      if (key === 'status') {
        var target = this.statusOptions.find(function (item) {
          return item.value === value;
        });
        return target && target[valueKey] || defaultValue;
      }
      return defaultValue;
    },
    handleRepair: function handleRepair(row) {
      var _this2 = this;
      this.$modal.confirm('是否确认补单？').then(function () {
        return repairOrderApi({
          orderDetailId: row.id
        });
      }).then(function () {
        _this2.refreshList();
        _this2.$modal.msgSuccess('补单成功');
      });
    }
  }
};